// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export const ESLINT_BULK_PATCH_PATH_ENV_VAR_NAME: 'RUSHSTACK_ESLINT_BULK_PATCH_PATH' =
  'RUSHSTACK_ESLINT_BULK_PATCH_PATH';
export const ESLINT_BULK_SUPPRESS_ENV_VAR_NAME: 'RUSHSTACK_ESLINT_BULK_SUPPRESS' =
  'RUSHSTACK_ESLINT_BULK_SUPPRESS';
export const ESLINT_BULK_ENABLE_ENV_VAR_NAME: 'ESLINT_BULK_ENABLE' = 'ESLINT_BULK_ENABLE';
export const ESLINT_BULK_PRUNE_ENV_VAR_NAME: 'ESLINT_BULK_PRUNE' = 'ESLINT_BULK_PRUNE';
export const ESLINT_BULK_DETECT_ENV_VAR_NAME: '_RUSHSTACK_ESLINT_BULK_DETECT' =
  '_RUSHSTACK_ESLINT_BULK_DETECT';
export const ESLINT_BULK_FORCE_REGENERATE_PATCH_ENV_VAR_NAME: 'RUSHSTACK_ESLINT_BULK_FORCE_REGENERATE_PATCH' =
  'RUSHSTACK_ESLINT_BULK_FORCE_REGENERATE_PATCH';
export const VSCODE_PID_ENV_VAR_NAME: 'VSCODE_PID' = 'VSCODE_PID';

export const ESLINT_BULK_STDOUT_START_DELIMETER: 'RUSHSTACK_ESLINT_BULK_START' =
  'RUSHSTACK_ESLINT_BULK_START';
export const ESLINT_BULK_STDOUT_END_DELIMETER: 'RUSHSTACK_ESLINT_BULK_END' = 'RUSHSTACK_ESLINT_BULK_END';

export const ESLINT_PACKAGE_NAME_ENV_VAR_NAME: '_RUSHSTACK_ESLINT_PACKAGE_NAME' =
  '_RUSHSTACK_ESLINT_PACKAGE_NAME';

export const BULK_SUPPRESSIONS_CLI_ESLINT_PACKAGE_NAME: string =
  process.env[ESLINT_PACKAGE_NAME_ENV_VAR_NAME] ?? 'eslint';
